import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useOfferCountdown } from '../hooks/useOfferCountdown';
interface OfferCountdownProps {
  variant?: 'block' | 'inline';
}
export function OfferCountdown({
  variant = 'block'
}: OfferCountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useOfferCountdown();
  const label = `La oferta termina en ${hours} horas, ${minutes} minutos y ${seconds} segundos`;
  if (variant === 'inline') {
    return <span className="font-display text-xs font-extrabold tabular-nums text-danger" aria-label={label} data-id="element-233" data-mp="1ca7tonhp3ew4">
        Termina en {hours}:{minutes}:{seconds}
      </span>;
  }
  const units = [{
    value: hours,
    unit: 'horas'
  }, {
    value: minutes,
    unit: 'min'
  }, {
    value: seconds,
    unit: 'seg'
  }];
  return <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 rounded-xl bg-danger-soft px-4 py-3" role="timer" aria-label={label} data-id="element-234" data-mp="2wo00m6qad2mm">
      <p className="flex items-center gap-2 text-sm font-bold text-danger" data-id="element-235" data-mp="31lrq6u3gkcnn">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="26q317ln1pc4d" />
        La oferta termina en
      </p>
      <div className="flex items-center gap-1.5" aria-hidden="true" data-id="element-237" data-mp="21qgnlb3b1tv1">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-238" data-mp="1wqu5oocj7pfw" data-mpi={i}>
            <span className="flex min-w-[3.25rem] flex-col items-center rounded-lg bg-danger px-2 py-1 text-white" data-id="element-239" data-mp="1wtq74mnl8w93">
              <span className="font-display text-xl font-black leading-none tabular-nums" data-id="element-240" data-mp="1ruwv6yny9db1">{u.value}</span>
              <span className="mt-0.5 text-[10px] font-semibold uppercase leading-none text-white/80" data-id="element-241" data-mp="1j08pj7egptlp">{u.unit}</span>
            </span>
            {i < units.length - 1 && <span className="font-display text-lg font-black text-danger" data-id="element-242" data-mp="1e1njusgfyhpv">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}